
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { mapGetters } from 'vuex';
import api from '../../api';
import UpLoad from '../../components/LoansUpload';
import validator from '../../api/validator';
export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
Group,
XInput,
PopupPicker,
Checker,
CheckerItem,
UpLoad,
XTextarea,
XButton,
},
mounted() {
this.getOldData();
this.getContact();
setTimeout(() => {
window.scrollTo(0, 0)
},1480)
},
activated() {
},
watch: {
addrArr(arr) {
this.formData.provice = arr[0];
if (arr[1] === '0') {
this.formData.city = arr[0];
} else {
this.formData.city = arr[1];
}
},
nature(arr) {
this.formData.nature = arr.join('');
},
taxrate(arr) {
this.formData.taxrate = arr.join(',');
},
},
data() {
return {
addrArr: [],
nature: [''],
taxrate: [],
address: [],
preCheck: [],
optionsNature: [['合资', '外资', '国企', '私企']],
formData: {
address: '',
taxrate: [],
logo: '',
provice: '',
city: '',
nature: [''], // 保存时还需要处理
name: '',
abbr: '',
description: '',
},
taxrateData: [
{ key: '0.03', value: '3%' },
{ key: '0.06', value: '6%' },
{ key: '0.09', value: '9%' },
],
formContacts: {
name: '',
mobile: '',
tel: '',
mail: '',
position: '',
status: 1,
},
rule: {
isMobile(val) {
return {
valid: validator.isMobile(val),
msg: '请输入正确的手机号码',
};
},
isTel(val) {
return {
valid: validator.isTel(val),
msg: '请输入正确的座机号码',
};
},
isMail(val) {
return {
valid: validator.isMail(val),
msg: '请输入正确的邮箱',
};
},
},
};
},
computed: {
companyStatus() {
return this.$store.state.companyStatus;
},
...mapGetters([
'isLower',
'isUpper',
]),
},
methods: {
getContact() {
api.vega.contact.listContacts({
pageNo: 1,
pageSize: 100,
}).then((res) => {
const data = res.data.data.result;
data.map((item) => {
if (item.status === 1) {
this.formContacts = item;
}
});
});
},
addrChange(val) {
if (val[0] !== this.preCheck[0]) {
this.getCity(val[0]);
}
this.preCheck = val;
},
natureChange(val) {
console.log(val);
},
getProvince() {
const data = _province;
data.map((item) => {
item.name = item.content;
item.value = item.id;
return item;
});
this.address = [data, [{
name: '--',
value: '0',
}]];
this.getCity(data[0].id);
},
getCity(id) {
const data = _city[id];
if(data.length) {
data.map((item) => {
item.name = item.content;
item.value = item.id;
return item;
});
const arr = [this.address[0], data];
this.address = arr;
} else {
const arr = [this.address[0], [{
name: '--',
value: '0',
}]];
this.address = arr;
}
},
getImgUrl(data) {
this.formData.logo = data.url;
},
save() {
if (!this.rule.isMobile(this.formContacts.mobile).valid || !this.rule.isTel(this.formContacts.tel).valid ||!this.rule.isMail(this.formContacts.mail).valid) {
this.$vux.toast.text('请填写正确的联系人信息');
} else {
api.vega.contact.updateContact(this.formContacts).then((res) => {
const code = res.data;
if (code.code === 0 && code.sub_code === 0 ) {
this.$vux.toast.text('保存成功');
const formData = this.formData;
if (formData.abbr === '' || formData.provice === '' || formData.address === '' || formData.nature === '' || formData.taxrate === '' || formData.description === '') {
this.$vux.toast.text('请完善信息');
} else {
api.vega.company.updateCompanyBaseInfo(formData).then((res) => {
const _this = this;
const code = res.data;
if (code.code === 0 && code.sub_code === 0) {
if (this.companyStatus !== 0) {
this.$vux.confirm.show({
showCancelButton: false,
confirmText: '我知道了',
content: `<i class="iconfont icon-chenggong"></i>
<p class="save_ok">保存成功</p>`,
onConfirm () {
_this.$router.go(-1);
}
});
} else {
if (this.isLower) {
this.$router.push({
name: 'authTransport',
});
} else {
this.$router.push({
name: 'authCompanyApt',
});
}
}
}
});
}
}
});
}
},
getOldData() {
api.vega.company.getCompanyBaseInfo({}).then((res) => {
const data = res.data.data;
console.log(data);
this.formData = { ...data };
this.addrArr = [data.provice, data.city];
this.nature = [data.nature];
this.taxrate = data.taxrate.split(',');
this.getProvince();
})
},
},
};
